import { Component, Inject, ElementRef, ViewChild, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EduFamilySurvey } from 'projects/shared-lib/src/lib/model/edu-family-survey.model';
import { Institution } from 'projects/shared-lib/src/public-api';
import { ParagraphUtil } from '../../shared/utils/paragraph.util';

@Component({
    selector: 'household-id-modal',
    templateUrl: './household-id-modal.component.html',
    styleUrls: ['./household-id-modal.component.css']
})
export class HouseholdIdModal implements AfterViewInit{
    @ViewChild('REDCapButton') redCapButton:ElementRef;

    public surveys: EduFamilySurvey[] = [];
    public redCapURL = "https://unmcredcap.unmc.edu/redcap/surveys/?s=LCNYL73XFA"
    constructor(public dialogRef: MatDialogRef<HouseholdIdModal>,
            public paragraphUtil: ParagraphUtil,
            private elementRef: ElementRef,
            @Inject(MAT_DIALOG_DATA) public data: {
        houseHoldId: string;
        surveys: EduFamilySurvey[];
        districts: Institution[];
    }){
        this.surveys = data.surveys;
     }

     ngAfterViewInit() {
        this.addREDCapEvent();
    }

    addREDCapEvent(){
        var buttonElem = this.elementRef.nativeElement.querySelector('.red-cap-click');
        if(buttonElem){
            buttonElem.addEventListener('click', this.openREDCapSurvey.bind(this))
        }
    }

    public onConfirm(){
        this.dialogRef.close(true);
    }

    public openREDCapSurvey(event) {
        event.preventDefault();
        this.redCapButton.nativeElement.click();
        this.dialogRef.close(true);
    }



    public getSchoolNameById(districtId, schoolId): string {
        let schoolName = "";
        let dist = this.data.districts.find(d => d.id == districtId);
        if(dist) {
            let school = dist.facilities.find(f => f.id == schoolId);
            if(school) schoolName = school.name;
        }
        return schoolName;
    }

    public getDistrictNameById(id): string {
        let districtName = "";
        let dist = this.data.districts.find(d => d.id == id);
        if(dist) districtName = dist.description;
        return districtName;
    }

    public getGradeNameById(districtId, schoolId, gradeId): string {
        let gradeName = "";
        let dist = this.data.districts.find(d => d.id == districtId);
        if(dist) {
            let school = dist.facilities.find(f => f.id == schoolId);
            if(school){
                let grade  = school.units.find(u => u.id == gradeId);
                if(grade) gradeName = grade.description;
            }
        }
        return gradeName;
    }


}
